import api from '../token';

export const ListMesaPedido = async () => {
  try {
    const response = await api.post('/getMesaPedido');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar produtos:', error);
    return [];
  }
};

